import { cn } from '../../../lib/utils'
import { numberUtil } from '../../../util/number-util'
import React from 'react'

interface WorkoutStatValueProps {
  children: React.ReactNode
  className?: string
}

export const WorkoutStatValue = ({ children, className }: WorkoutStatValueProps): React.ReactElement => {
  const formattedValue = numberUtil.formatNumber(children as number | string)

  return (
    <h2 className={cn('font-evogria text-6xl font-normal leading-none text-ivory uppercase', className)}>{formattedValue}</h2>
  )
}
